exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".take-space{position:relative!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.css"],"names":[],"mappings":"AAAA,YACE,2BAA8B,CAC/B","file":"validation-message.component.css","sourcesContent":[".take-space {\n  position: relative !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.css
// module id = b9Cn
// module chunks = 0